<section class="plans-wrap">

<div class="mini-disclosure-red"  (click)="showUnpaid = true" *ngIf="unpaid && unpaid.count && unpaid.count.length > 0  && !comingFromDeposit">
  <span class="mini-icon">⚖</span>
  <span>
    You have a pending purchase, click to view
  </span>
</div>


<div *ngIf="showUnpaid || comingFromDeposit">
      <!-- ================= UNPAID PAYMENT ================= -->
  <div *ngIf="unpaid && unpaid.count && unpaid.count.length > 0" class="alert alert-warning" role="alert">

    <h4>Complete Payment</h4>

    <ng-container *ngIf="unpaid.count[0] as payment">

      <div class="wrapper-bill">

        <div class="archive-bottom">

          <p style="color:blue;font-weight:600;text-align:center;font-size:24px;margin-bottom:30px;">
            <span *ngIf="payment.pay_mode == 'Bank' || payment.pay_mode == 'UPI'">₹{{ payment.amount * 89 | number:'1.0-0' }}</span>
            <span *ngIf="payment.pay_mode != 'Bank' && payment.pay_mode != 'UPI'">{{ payment.amount | currency }}</span>
          </p>

          <ul>
            <li class="list-info-bill">
              Package
              <span>{{ payment.plan }} - {{ payment.gram }} gram</span>
            </li>

            <li class="list-info-bill" *ngIf="payment.plan != 'ownership'">
              Profit
              <span *ngIf="payment.pay_mode == 'Bank' || payment.pay_mode == 'UPI'">₹{{ payment.expected_roi * 89 | number:'1.0-0' }}</span>
             <span *ngIf="payment.pay_mode != 'Bank' && payment.pay_mode != 'UPI'">{{ payment.expected_roi | currency }}</span>
            </li>

            <li class="list-info-bill" *ngIf="payment.plan != 'ownership'">
              Duration
              <span>{{ payment.duration }} days</span>
            </li>

            <li class="list-info-bill">
              Payment Method
              <span class="text-end">{{ payment.pay_mode }}</span>
            </li>
          </ul>

        </div>

        <div *ngIf="payment.pay_mode != 'Bank'">

          <input
          type="text"
          class="form-control form-control-lg mt-2 mb-2"
          [value]="payment.pay_mode == 'UPI' ? unpaid.address.split(',')[0] : unpaid.address"
          readonly
        />

        <input
          *ngIf="unpaid.tic == 'UPI'"
          type="text"
          class="form-control form-control-lg mt-2 mb-2"
          [value]="unpaid.upname"
          readonly
        />
        </div>


        <div *ngIf="payment.pay_mode == 'Bank'">
          <div class="container">
            <div class="row">
              <div class="col-xl-12 col-lg-12 col-md-12">
                <div *ngFor="let item of unpaid.bank">
                  <div class="row justify-content-center">
                    <div class="col-md-12 mb-3">
                      <div class="">
                        <div class="rounded-bottom  text-white">
                          <label style="color: black;">Bank name</label>
                          <input
                            type="text"
                            id="address"
                            class="form-control form-control-lg mt-2 mb-2"
                            [value]="item.Bank"
                            readonly=""
                          />
                          <label style="color: black;">Account number</label>
                          <input
                            type="text"
                            id="address"
                            class="form-control form-control-lg mt-2 mb-2"
                            [value]="item.Account"
                            readonly=""
                          />
                          <label style="color: black;">Account name</label>
                          <input
                            type="text"
                            id="address"
                            class="form-control form-control-lg mt-2 mb-2"
                            [value]="item.Accountname"
                            readonly=""
                          />
                          <label style="color: black;">IFSC CODE</label>
                          <input
                            type="text"
                            id="address"
                            class="form-control form-control-lg mt-2 mb-2"
                            [value]="item.branch"
                            readonly=""
                          />
                          <label style="color: black;">Amount</label>
                          <input
                            type="text"
                            id="address"
                            class="form-control form-control-lg mt-2 mb-2"
                            [value]="'₹' + payment.amount * 89"
                            readonly=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div style="display: flex; flex-direction: row; gap: 10px">

       <button
        type="button"
        (click)="goHome()"
        class="tf-btn accent large"
        style="background-color:red;color:white;margin-top:40px;"
      >
        Go Home
      </button>



          <button
      type="button"
      (click)="paid(payment.deposite_id)"
      class="tf-btn accent large"
      style="background-color:green;color:white;margin-top:40px;"
    >
      I have Paid
    </button>
        </div>

        <!-- <button
          class="btn btn-lg mb-2"
          style="background:gold;color:black;font-weight:600;width:100%;"
          (click)="copy()"
        >
          COPY
        </button> -->

      </div>

      <div style="padding:15px;margin-top:-40px;">
        <p>STEP 1: Send  <span *ngIf="payment.pay_mode == 'Bank' || payment.pay_mode == 'UPI'">₹{{ payment.amount * 89 |  number:'1.0-0' }}</span> <span *ngIf="payment.pay_mode != 'Bank' && payment.pay_mode != 'UPI'">{{ payment.amount | currency }}</span> to the details above</p>
        <p>STEP 2: After making payment, Click on "I have paid"</p>
      </div>





    </ng-container>



  </div>
</div>


<div *ngIf="!showUnpaid && !comingFromDeposit">


    <div *ngIf="promo == 1" class="alert alert-info" role="alert" style="margin-bottom: 40px;">
       <div class="mini-disclosure">
        <span class="mini-icon">⚖</span>
        <span>
          🌟4-DAY BULLION ACTIVATION FOR ACTIVE INVESTORS ONLY🌟
        </span>
        <br/>
        <span>
        This is not a public offer.
        This is a capital expansion phase reserved strictly for committed investors.
        </span>
      </div>
      <p>
        This phase is structured to reward serious capital movement.
        If your account is active and above the required threshold, participation is expected to maintain your positioning for upcoming premium cycles.
      </p>
      ⚠️ This window is open for 4 days only.
     <br/>
     <br/>
       <article class="plan-card" style="border:2px solid gold;" >

        <div class="plan-img">
          <img src="https://laap.org/img/2.5g.webp">
        </div>

        <div class="plan-body">

          <h3 class="plan-title">
           <span class="badge">🔶</span>
            BULLION PLAN
          </h3>

          <p class="plan-price">
            💰 Investment: <strong>$2,000</strong>
          </p>

          <ul class="plan-meta">
            <li><span>Profit:</span> <strong>500%</strong></li>
            <li><span>Duration:</span> <strong>4 days</strong></li>
          </ul>

        </div>

        <a
          class="plan-buy"
          [routerLink]="['deposit']"
          [queryParams]="{
            option:'bullion',
            amount: 2000,
            duration: 4,
            per: 6
          }"
        >
          Buy
        </a>

      </article>
      <br>

      <article class="plan-card" style="border:2px solid gold;" >

        <div class="plan-img">
          <img src="https://laap.org/img/2.5g.webp">
        </div>

        <div class="plan-body">

          <h3 class="plan-title">
           <span class="badge">🔷</span>
            FORTIS BULLION (Elite Tier)
          </h3>

          <p class="plan-price">
           💰 Investment: <strong>$10,000</strong>
          </p>

          <ul class="plan-meta">
            <li><span>Profit:</span> <strong>600%</strong></li>
            <li><span>Duration:</span> <strong>4 days</strong></li>
          </ul>

        </div>

        <a
          class="plan-buy"
          [routerLink]="['deposit']"
          [queryParams]="{
            option:'fortis',
            amount: 10000,
            duration: 4,
            per: 7
          }"
        >
          Buy
        </a>

      </article>
    </div>

   <!-- ===== Compact Premium Notice ===== -->
<div class="mini-disclosure">
  <span class="mini-icon">⚖</span>
  <span>
    Listed profits represent the <strong>minimum guaranteed return</strong>.
    Returns may be higher based on market performance.
  </span>
</div>


   <!-- ================= NO UNPAID PAYMENT ================= -->
   <div  class="alert alert-success plans-wrap">



    <!-- SPECIAL PACKAGE -->
    <div *ngIf="special && special.length > 0">

      <h4>SPECIAL PACKAGE (Specifically for you)</h4>
      <br><br>

      <article class="plan-card" style="border:2px solid gold;" *ngIf="special[0] as sp">

        <div class="plan-img">
          <img src="https://laap.org/img/2.5g.webp">
        </div>

        <div class="plan-body">

          <h3 class="plan-title">
            <span class="badge">🏅</span>
            Special Bullion - {{ sp.gram }} grams
          </h3>

          <p class="plan-price">
           💰 Investment: <strong>{{ sp.price | currency }}</strong>
          </p>

          <ul class="plan-meta">
            <li><span>Gram:</span> <strong>{{ sp.gram }} grams</strong></li>
            <li><span>Profit:</span> <strong>{{ ((sp.per - 1) * 100) | number:'1.2-2' }}%</strong></li>
            <li><span>Duration:</span> <strong>{{ sp.duration }} days</strong></li>
          </ul>

        </div>

        <a
          class="plan-buy"
          [routerLink]="['deposit']"
          [queryParams]="{
            option:'special',
            amount: sp.price,
            gram: sp.gram,
            duration: sp.duration,
            per: sp.per
          }"
        >
          Buy
        </a>

      </article>

    </div>




    <div>
  <h4>WEEKLY PACKAGE (Bullion-Backed Digital Gold)</h4>
  <br>
  <br>

  <div class="plans-grid">

    <!-- Starter Pack -->
    <article class="plan-card">
      <div class="plan-img">
        <img src="https://laap.org/img/1g.webp" alt="Starter Pack" />
      </div>

      <div class="plan-body">
        <h3 class="plan-title">
          <span class="badge">🥉</span>
          Starter Pack
        </h3>

        <p class="plan-price">
         💰 Investment: <strong>$39 – $260</strong>
        </p>

        <ul class="plan-meta">
          <li><span>🪙 Gold:</span> <strong>0.3g – 2g</strong></li>
          <li><span>📊 Profit:</span> <strong>5% – 6%</strong></li>
          <li><span>⏱️  Duration:</span> <strong>15 Hours</strong></li>
          <li><span>🎁 Referral Bonus:</span> <strong>2%</strong></li>
        </ul>
      </div>

      <a
        class="plan-buy"
        [routerLink]="['deposit']"
        [queryParams]="{ option: 'starter', amount: 39 }"
      >
        Buy
      </a>
    </article>

    <!-- Prime Bullion -->
    <article class="plan-card">
      <div class="plan-img">
        <img src="https://laap.org/img/2.5g.webp" alt="Prime Bullion Pack" />
      </div>

      <div class="plan-body">
        <h3 class="plan-title">
          <span class="badge">🥈</span>
          Prime Bullion Pack
        </h3>

        <p class="plan-price">
         💰 Investment: <strong>$325 – $585</strong>
        </p>

        <ul class="plan-meta">
          <li><span>🪙 Gold:</span> <strong>2.5g – 4.5g</strong></li>
          <li><span>📊 Profit:</span> <strong>7% – 9%</strong></li>
          <li><span>⏱️  Duration:</span> <strong>24 Hours</strong></li>
          <li><span>🎁 Referral Bonus:</span> <strong>2%</strong></li>
        </ul>
      </div>

      <a
        class="plan-buy"
        [routerLink]="['deposit']"
        [queryParams]="{ option: 'prime', amount: 325 }"
      >
        Buy
      </a>
    </article>

    <!-- Elite Vault -->
    <article class="plan-card">
      <div class="plan-img">
        <img src="https://laap.org/img/5g.webp" alt="Elite Vault Pack" />
      </div>

      <div class="plan-body">
        <h3 class="plan-title">
          <span class="badge">🥇</span>
          Elite Vault Pack
        </h3>

        <p class="plan-price">
         💰 Investment: <strong>$650 – $1,300</strong>
        </p>

        <ul class="plan-meta">
          <li><span>🪙 Gold:</span> <strong>5g – 10g</strong></li>
          <li><span>📊 Profit:</span> <strong>10% – 13%</strong></li>
          <li><span>⏱️  Duration:</span> <strong>4 Days</strong></li>
          <li><span>🎁 Referral Bonus:</span> <strong>3%</strong></li>
        </ul>
      </div>

      <a
        class="plan-buy"
        [routerLink]="['deposit']"
        [queryParams]="{ option: 'elite', amount: 650 }"
      >
        Buy
      </a>
    </article>

    <!-- Sovereign -->
    <article class="plan-card">
      <div class="plan-img">
        <img src="https://laap.org/img/5g.webp" alt="Sovereign Pack" />
      </div>

      <div class="plan-body">
        <h3 class="plan-title">
          <span class="badge">👑</span>
          Sovereign Pack
        </h3>

        <p class="plan-price">
          💰 Investment: <strong>$1,950 – $6,500</strong>
        </p>

        <ul class="plan-meta">
          <li><span>🪙 Gold:</span> <strong>15g – 50g</strong></li>
          <li><span>📊 Profit:</span> <strong>18% – 25%</strong></li>
          <li><span>⏱️  Duration:</span> <strong>10 Days</strong></li>
          <li><span>🎁 Referral Bonus:</span> <strong>4%</strong></li>
        </ul>
      </div>

      <a
        class="plan-buy"
        [routerLink]="['deposit']"
        [queryParams]="{ option: 'sovereign', amount: 1950 }"
      >
        Buy
      </a>
    </article>

    <!-- Aurum Reserve -->
    <article class="plan-card">
      <div class="plan-img">
        <img src="https://laap.org/img/5g.webp" alt="Aurum Reserve Pack" />
      </div>

      <div class="plan-body">
        <h3 class="plan-title">
          <span class="badge">💎</span>
          Aurum Reserve Pack
        </h3>

        <p class="plan-price">
          💰 Investment: <strong>$7,800 – $13,000</strong>
        </p>

        <ul class="plan-meta">
          <li><span>🪙 Gold:</span> <strong>60g – 100g</strong></li>
          <li><span>📊 Profit:</span> <strong>28% – 35%</strong></li>
          <li><span>⏱️  Duration:</span> <strong>15 Days</strong></li>
          <li><span>🎁 Referral Bonus:</span> <strong>5%</strong></li>
        </ul>
      </div>

      <a
        class="plan-buy"
        [routerLink]="['deposit']"
        [queryParams]="{ option: 'aurum', amount: 7800 }"
      >
        Buy
      </a>
    </article>

  </div>
</div>

   <div>
  <h4>📈 ELITE MONTHLY WEALTH PACKAGES</h4>
  <p>Built for long-term premium investors</p>

  <br>
  <br>

  <div class="plans-grid">

    <!-- Classic Pack -->
    <article class="plan-card">
      <div class="plan-img">
        <img src="https://laap.org/img/1g.webp" alt="Classic Pack" />
      </div>

      <div class="plan-body">
        <h3 class="plan-title">
          <span class="badge">🪙</span>
          Classic Pack
        </h3>

        <p class="plan-price">
        <strong>🔥 Beginner Favorite</strong>
        </p>


        <p class="plan-price">
         💰  Investment: <strong>$130 – $1,300</strong>
        </p>

        <ul class="plan-meta">
          <li><span>🪙 Gold:</span> <strong>1g – 10g</strong></li>
          <li><span> 📊 Daily Profit:</span> <strong>2%</strong></li>
          <li><span>💹 Monthly Return:</span> <strong>60%</strong></li>
          <li><span>⏱️ Duration:</span> <strong>30 Days</strong></li>
          <li><span> 🎁 Referral Bonus:</span> <strong>5%</strong></li>
        </ul>
      </div>

      <a
        class="plan-buy"
        [routerLink]="['deposit']"
        [queryParams]="{ option: 'classic', amount: 130 }"
      >
        Buy
      </a>
    </article>

    <!-- Prestige Tier -->
    <article class="plan-card">
      <div class="plan-img">
        <img src="https://laap.org/img/2.5g.webp" alt="Prestige Tier" />
      </div>

      <div class="plan-body">
        <h3 class="plan-title">
          <span class="badge">🏆</span>
          Prestige Tier
        </h3>

        <p class="plan-price">
        <strong>⭐ MOST POPULAR</strong>
        </p>

        <p class="plan-price">
         💰 Investment: <strong>$1,950 – $6,500</strong>
        </p>

        <ul class="plan-meta">
          <li><span>🪙 Gold:</span> <strong>15g – 50g</strong></li>
          <li><span> 📊 Daily Profit:</span> <strong>3.5%</strong></li>
          <li><span> 📈 Monthly Return:</span> <strong>105%</strong></li>
          <li><span> ⏱️ Duration:</span> <strong>30 Days</strong></li>
          <li><span> 🎁 Referral Bonus:</span> <strong>6%</strong></li>
        </ul>
      </div>

      <a
        class="plan-buy"
        [routerLink]="['deposit']"
        [queryParams]="{ option: 'prestige', amount: 1950 }"
      >
        Buy
      </a>
    </article>

    <!-- Elite Tier -->
    <article class="plan-card">
      <div class="plan-img">
        <img src="https://laap.org/img/5g.webp" alt="Elite Tier" />
      </div>

      <div class="plan-body">
        <h3 class="plan-title">
          <span class="badge">💼</span>
          Elite Tier
        </h3>

        <p class="plan-price">
        <strong>👑 BEST LONG-TERM VALUE</strong>
        </p>

        <p class="plan-price">
         💰 Investment: <strong>$7,800 – $13,000</strong>
        </p>

        <ul class="plan-meta">
          <li><span>🪙 Gold:</span> <strong>60g – 100g</strong></li>
          <li><span> 📊 Daily Profit:</span> <strong>4.5%</strong></li>
          <li><span> 📈 Monthly Return:</span> <strong>135%</strong></li>
          <li><span> ⏱️ Duration:</span> <strong>30 Days</strong></li>
          <li><span> 🎁 Referral Bonus:</span> <strong>7%</strong></li>
        </ul>
      </div>

      <a
        class="plan-buy"
        [routerLink]="['deposit']"
        [queryParams]="{ option: 'elite-tier', amount: 7800 }"
      >
        Buy
      </a>
    </article>

    <!-- Platinum Pack -->
    <article class="plan-card">
      <div class="plan-img">
        <img src="https://laap.org/img/5g.webp" alt="Platinum Pack" />
      </div>

      <div class="plan-body">
        <h3 class="plan-title">
          <span class="badge">💎</span>
          Platinum Pack
        </h3>


        <p class="plan-price">
          <strong>🚀 HIGH-NET-WORTH PREMIUM PLAN</strong>
        </p>

        <p class="plan-price">
         💰 Investment: <strong>$19,500 – $500,000</strong>
        </p>

        <ul class="plan-meta">
          <li><span>🪙 Gold:</span> <strong>150g – 3846g</strong></li>
          <li><span> 📊 Daily Profit:</span> <strong>6%</strong></li>
          <li><span> 📈 Monthly Return:</span> <strong>180%</strong></li>
          <li><span> ⏱️ Duration:</span> <strong>30 Days</strong></li>
          <li><span> 🎁 Referral Bonus:</span> <strong>8%</strong></li>
        </ul>
      </div>

      <a
        class="plan-buy"
        [routerLink]="['deposit']"
        [queryParams]="{ option: 'platinum', amount: 19500 }"
      >
        Buy
      </a>
    </article>

  </div>
</div>


     <div>
     <h4>Private Clients (‍Direct Physical Ownership - Sovereign Storage)</h4>
     <p>
      Take physical possession of your allocated precious metals whenever you choose with direct delivery.
     </p>
     <br>

      <article class="plan-card">
        <div class="plan-img">
          <img src="https://laap.org/img/1g.webp" alt="Starter Gold" />
        </div>
        <div class="plan-body" style="align-items: center; display: flex; justify-content: center;">
         <h3>
          Bank-free sovereign storage ensures your gold remains fully under your control independent from the traditional banking system
         </h3>
        </div>
        <a class="plan-buy" [routerLink]="['deposit']" [queryParams]="{ option: 'ownership', amount: 5000 }">Take Physical Ownership</a>
      </article>

    </div>

  </div>
</div>

</section>

